<app-entity-activities 
    [jobId]="jobId" 
    [activityMap]="activityMap"
    [requisitionInfo]="infoForActivities"
    context="requisition">
</app-entity-activities>